import React from 'react';
import { connect } from 'react-redux';
import HoverListDescription from '@/components/list/HoverListDescription';
import { editRole } from '../actions';

const RoleListDescription = ({
  code,
  category,
  value,
  canEdit,
  showEdit,
  disabled,
}) => (
  <HoverListDescription
    value={value}
    canEdit={canEdit}
    showEdit={() => showEdit(category, code)}
    className="aridhia-role-list-description"
    disabled={disabled}
  />
);

const mapDispatchToProps = {
  showEdit: editRole,
};

export default connect(null, mapDispatchToProps)(RoleListDescription);
